export enum  NotificationConsent{

    NOT_ACCEPTED = 'NOT_ACCEPTED' ,

    MOBILE = 'MOBILE' ,

    EMAIL = 'EMAIL' ,

    MANUAL = 'MANUAL' ,

    ALL = 'ALL'
}